<template>
  <div class="container-fluid px-0" style="min-height: 100vh">
    <navbarLogin></navbarLogin>
    <div class="row" style="max-width: 100vw">
      <div class="col-lg-2 col-md-2 col-sm-2 col-2" style="max-height: 100vh;">
      </div>
      <div class="col-lg-8 col-md-8 col-sm-8 col-8">
        <!-- <navbarLogin></navbarLogin> -->
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-5 text-left">
            <div class="signup">Sign Up</div>
            <div class="getstarted mt-4">
                 Get started with a few simple
                 details and discover the unlimited potential of our data
            </div>
            <form>
              <div class="form-group">
                <label>Name</label>
                <input
                  v-model="name"
                  type="text"
                  class="form-control input-lg"
                  id="username"
                  @change="validateName"
                  v-on:keyup.13="signup"
                  @keydown="validateName"
                required/>
                <span v-if="!isValidName" id="warningText">*{{isValidNameMessage}}</span>
              </div>
              <div class="form-group">
                <label>Email Address</label>
                <input
                  v-model="email"
                  type="email"
                  class="form-control input-lg"
                  id="email"
                  @change="validateEmail"
                  aria-describedby="emailHelp"
                  v-on:keyup.13="signup"
                required/>
                <span v-if="!isvalidEmail" id="warningText">*{{validateEmailreq}}</span>
              </div>
              <div class="form-group">
                <label>Contact No.</label>
                <vue-tel-input v-on:keyup.13="signup" ref="vuetelInput" class="vuetel" v-model="phone" v-bind="bindProps"></vue-tel-input>
                <span v-if="!isValidnu" id="warningText">*{{validateNum}}</span>
              </div>
              <div class="form-group">
                <label>Company</label>
                <input
                  v-model="company"
                  type="text"
                  class="form-control input-lg"
                  id="company"
                  @change="validatecompany"
                  @keydown="validatecompany"
                  aria-describedby="emailHelp"
                  v-on:keyup.13="signup"
                required/>
                <span v-if="!isValidCompany" id="warningText">*{{validCompanyMessage}}</span>
              </div>
              <div class="form-group">
                <label>Password</label>
                <input
                  v-model="password"
                  type="password"
                  class="form-control input-lg"
                  id="password"
                  @change="validatePassword"
                  placeholder="* * * * * * * *"
                  v-on:keyup.13="signup"
                  @keydown="validatePassword()"
                required/>
                <span v-if="!isvalidPassword" id="warningText">{{password.length == 0 ? passwordMessage :validatePasswordReq}}</span>
              </div>
              <div class="button pt-3">
                <vue-recaptcha
                  ref="recaptcha"
                  @verify="onCaptchaVerified"
                  @expired="onCaptchaExpired"
                  size="invisible"
                  sitekey="6Ldwtr0UAAAAAF--eORDJK5nF18ydD5tFchWnilY">
                </vue-recaptcha>
                <button type="button" @click="signup" class="btn btn-primary signupbtn" >Submit</button>
                <span class="already" @click="existingAccount">I already have an account</span>
              </div>
            </form>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-6 d-none d-sm-block img-container">
            <img src="../assets/Group 4.png" class="img-fluid" alt="group 4 img" />
          </div>
        </div>
      </div>

      <div class="col-lg-2 col-md-2 col-sm-2 col-2">
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import $ from 'jquery'
import Vue from 'vue'
import VueRecaptcha from 'vue-recaptcha'
import Toasted from 'vue-toasted'
import { AUTH_SIGNUP } from '../store/actions/auth'
import navbarLogin from './navbarLogin'

Vue.use(Toasted)

export default {
  data() {
    return {
      sitekey: process.env.RECA_KEY,
      bindProps: {
        mode: 'international',
        defaultCountry: 'IN',
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: 'Enter a phone number',
        required: false,
        enabledCountryCode: false,
        enabledFlags: true,
        preferredCountries: ['USA', 'IN'],
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: 'off',
        maxLen: 25,
        invalidMsg: 'enter valid number',
        wrapperClasses: '',
        inputClasses: '',
        dropdownOptions: {
          disabledDialCode: false
        },
        inputOptions: {
          showDialCode: false
        }
      },
      phone: '',
      name: '',
      password: '',
      email: '',
      company: '',
      isValidCompany: true,
      validCompanyMessage: 'company name required',
      isValidName: true,
      isValidNameMessage: 'name required',
      isValidnu: true,
      hidePassword: true,
      isvalidEmail: true,
      isvalidPassword: true,
      emailMessage: '',
      passwordMessage: '',
      rules: [
        { message: 'One lowercase letter.', regex: /[a-z]+/ },
        { message: 'One uppercase letter.', regex: /[A-Z]+/ },
        { message: 'minimum 8 characters.', regex: /.{8,}/ },
        { message: 'One number.', regex: /[0-9]+/ },
        { message: 'One Special character', regex: /[!@#$%^&*(),.?":{}|<>]/ }
      ]
    }
  },
  watch: {
  },
  computed: {
    validateNum() {
      this.isValidnu = this.$refs.vuetelInput._computedWatchers.phoneObject.value.isValid
      if (this.phone === '') {
        return 'contact no. required'
      } else if (!this.isValidnu) {
        return 'enter valid number'
      }
    },
    validateEmailreq() {
      if (this.email === '') {
        return 'Email Required'
      } else {
        this.validateEmail()
        return this.emailMessage
      }
    },
    validatePasswordReq() {
      // alert()
      if (this.password === '') {
        return 'Password Required'
        // return
      }
      let errors = []
      for (let condition of this.rules) {
        if (!condition.regex.test(this.password)) {
          errors.push(condition.message + '\n')
        }
      }
			if (errors.length === 0) {
        this.passwordMessage = ''
        $('#password').css('border-color', '#ced4da')
				return
			} else {
        this.validatePassword()
        this.passwordMessage = ''
        this.passwordMessage = '*' + errors.join('')
        return '*' + errors.join('') + 'required'
      }
    }
  },
  components: {
    'vue-recaptcha': VueRecaptcha,
    'navbarLogin': navbarLogin,
    // 'signup2': signup2
  },
  mounted() {
    // this.name = this.name.split("@")[0]
    $('#username').keypress((e) => {
      var k
      document.all ? k = e.keyCode : k = e.which
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57))
    })
    $('[name="telephone"]').keypress((evt) => {
      var charCode = (evt.which) ? evt.which : event.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false
      }
      this.isValidnu = this.$refs.vuetelInput._computedWatchers.phoneObject.value.isValid
      return true
    })
  },
  methods: {
    validatecompany() {
      if (this.company === '') {
        this.isValidCompany = false
        $('#company').css('border-color', 'red')
      } else {
        this.isValidCompany = true
        $('#company').css('border-color', '#ced4da')
        // $('#company').css('border-color','red')
      }
    },
    validateName() {
      if (this.name === '') {
        this.isValidName = false
        $('#username').css('border-color', 'red')
      } else {
        $('#username').css('border-color', '#ced4da')
        this.isValidName = true
      }
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },
    onCaptchaVerified(recaptchaToken) {
      this.name = this.name.replace(/[^a-zA-Z0-9 ]/g, '')
      let newNum = this.phone.replace(/ /g, '')
      newNum = newNum.replace(/[+]/, '')
      newNum = Number(newNum)
      const self = this
      self.status = 'submitting'
      self.$refs.recaptcha.reset()
      const name = this.name
      const email = this.email
      const company = this.company
      const password = this.password
      const phone = newNum
      const source = 'apiKey'
      this.$store.dispatch(AUTH_SIGNUP, { recaptchaToken, email, company, phone, password, name, source })
        .then(() => {
          this.$router.push('/dash')
        })
        .catch((error) => {
          if (error.response.data.err.code === 11000) {
            this.$toasted.show('Email already exist', { duration: 2000 });
          }
        })
    },
    validateEmail() {
      /* eslint-disable */
      // use regex for email validation properly
      var field = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      // var failedValidation = this.email.indexOf('@') === -1
      if (!field.test(this.email)) {
        this.isvalidEmail = false
        this.emailMessage = 'Please enter a valid email address.'
        $('#email').css('border-color', 'red')
      } else {
        this.isvalidEmail = true
        $('#email').css('border-color', '#ced4da')
        // this.isEmail = true
      }
      this.message = ''
    },
    validatePassword() {
      /* eslint-disable */
      var field = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
      if (!field.test(this.password)) {
        this.isvalidPassword = false
        this.passwordMessage = 'password required'
        // this.validatePasswordReq = 'Minimum 8 character \n One Uppercase \n One lowecase \n one special char'
        $('#password').css('border-color', 'red')
      } else {
        this.isvalidPassword = true
        $('#password').css('border-color', '#ced4da')
      }
    },
    signup() {
      if (this.phone === '' || !this.isvalidEmail || !this.isvalidPassword || this.company === '' || this.isvalidEmail === '' || this.isvalidPassword === '') {
        this.validatecompany()
        this.validateName()
        this.validatePassword()
        this.validateEmail()
        // this.validateNum()
        this.$toasted.show('Please enter valid Inputs', { duration: 1500 })
        return
      } else {
        this.$refs.recaptcha.execute()
      }
    },
    existingAccount() {
      this.$router.push('/login')
    }
  }
}
</script>
<style scoped>
.vuetel {
    height: 42px;
    border: 1px solid #ced4da;
}
.signup {
  font-family: "Ubuntu";
  font-weight: 700;
  font-size: 38px;
  color: #3b3b3b;
  text-align: left;
  margin-top: 10%;
}
.getstarted {
  opacity: 0.7;
  font-family: "Ubuntu";
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
  line-height: 24px;
}
label {
  font-family: "Ubuntu";
  font-weight: 400;
  font-size: 12px;
  color: #606060;
  padding-left: 5px;
  padding-right: 5px;
}
.signupbtn {
  background: #2295c8;
  border-radius: 30px;
  width: 108px;
  height: 44px;
  font-family: "ubuntu";
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  border: none;
}
.already {
  font-family: "ubuntu";
  font-weight: 500;
  font-size: 14px;
  color: #2295c8;
  line-height: 20px;
  margin-left: 5%;
  cursor: pointer;
}
.signupbtn:hover {
  background: #2295c8;
}
.img-container {
  margin-top: 10%;
  width: 100%;
}
.form-group > label {
  position: relative;
  left: 19px;
  top: 15px;
  background: white;
}
.input {
  padding-top: 2px;
}
@media only screen and (max-width: 600px) {
  .already {
    display: inline-block;
    padding-top: 1rem;
  }
}
#warningText {
  font-size: 12px;
  color: red;
  font-family: "Ubuntu";
}
.imageRight {
  position: fixed;
  right: -24px;
  top: -42px;
  pointer-events: none;
}
.imageLeft {
  position: fixed;
  bottom: -31px;
  left: -90px;
}
@media screen and (max-width: 34em) {
  .imageRight {
    margin-left: -90px !important;
  }
  .button {
    display: grid;
  }
}

</style>
